// src/pages/Encuesta.jsx
import React from 'react';
import NPS from '../components/NPS/NPS';
import styles from './Encuesta.module.scss';

const EncuestaPage = () => (
  <main className={styles.page}>
    <NPS />
  </main>
);

export default EncuestaPage;
